import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  buttonIcon: {
    marginRight: theme.spacing(0.5)
  },
  infoIcon: {
    color: theme.vars.palette.info.main,
    marginLeft: theme.spacing(1)
  },
  sensorsList: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(0, 0, 1, 2)
  },
  sensorsListItem: {
    padding: 0
  },
  queryInfo: {
    backgroundColor: theme.vars.palette.background.navigation,
    fontSize: '0.875rem'
  }
}));

export default useStyles;
